import script from "./Election.vue?vue&type=script&setup=true&lang=ts"
export * from "./Election.vue?vue&type=script&setup=true&lang=ts"

import "./Election.vue?vue&type=style&index=0&id=09f5b917&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f5b917"]])

export default __exports__